import React, { useEffect, useState, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { EditShops } from './Form';
import { getShops, deleteShops, getShopsByCom } from '../../../Utility/Api';
import { WarehouseContext } from '../../../Utility/UserContext';
import { toast } from 'react-toastify';
import { Deletemodel } from '../../Common/Functions';
import { company_logo, NaviGate, setLocalStorage } from '../../../Utility/function';

const ShopsBranch = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const { state } = location;
  const [addoredit, setaddoredit] = useState();
  const [Shops, setShops] = useState();
  const [selectedShops, setSelectedShops] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState({});
  const [ShowEditModal, setShowEditModal] = useState(false);
  const { shopItem, setShopItem, subCompany, setSubCompany } = useContext(WarehouseContext);
  const [deletemodel, showDeletemodel] = useState(false);
  const [deleteID, setDeleteID] = useState("");
  const [search, setSearch] = useState("");

  // useEffect(() => {
  //   fetchShops()
  // }, [])
  useEffect(() => {
    fetchShops()
  }, [])

  const fetchShops = async (page = 1, text = "") => {
    try {
      let response;
      // if (subCompany?.id) {
      response = await getShopsByCom();
      // response = await getShopsByCom(subCompany.id);
      console.log("getShops response1:", response);
      // } else {
      //   response = await getShops(page, text);
      //   console.log("getShops response:", response);
      // }

      if (response?.data?.data) {
        var data = response.data.data.map((item) => ({
          ...item,
          shop_id: item.shop_id || item.id,
          shop_title: item.shop_title || item.title,
        }));

        setShops(data);
      } else {
        setShops([]);
      }
    } catch (error) {
      console.error('Error fetching shops data:', error);
      setShops([]);
    }
  };

  const openAddModal = () => {
    setSelectedShops(false)
    setSelectedBranch()
    setaddoredit(true)
    setShowEditModal(!ShowEditModal)
  }

  const openEditModal = (cat) => {
    setaddoredit(false)
    setShowEditModal(!ShowEditModal)
  }

  const handledeleteModal = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  }

  const handleDelete = async () => {
    try {
      const deleteItem = await deleteShops(deleteID);
      console.log(deleteItem);
      toast.success("Item Deleted success fully")
      const currentShopId = shopItem?.shop_id || shopItem?.id;
      if (currentShopId && String(currentShopId) === String(deleteID)) {
        setLocalStorage("SHOP", "null");
        setShopItem(null);
        window.location.reload();
      } else {
        await fetchShops();
        showDeletemodel(false)
      }
    } catch (err) {
      console.error("Error deleting shop:", err);
    }
  };

  const handleEdit = (shop) => {
    setaddoredit(false)

    const Payload = {
      id: shop.shop_id,
      title: shop.shop_title,
      Address: shop.Address,
      phone1: shop.phone1,
      phone2: shop.phone2,
      email: shop.email,
      vat_no: shop.vat_no,
      branch_id: shop.branch_id,
      ...shop
    }
    setSelectedShops(Payload)
    setShowEditModal(!ShowEditModal)
  }

  return (
    <div className='container-fluid d-flex align-items-center' >
      <div className=" mt-4 mx-3 pb-5 w-100">
        <div className='d-flex w-100 justify-content-center'>
          <div className="col-4 position-relative" style={{ width: "30%" }}>
            <input
              type="text"
              className="form-control form-control-sm mt-4"
              placeholder="Search..."
              onChange={(e) => setSearch(e.target.value)}
            />
            <img
              src="/assets/images/icons/search.png"
              alt="Search Icon"
              style={{
                position: "absolute",
                right: "12px",
                top: "70%",
                transform: "translateY(-50%)",
                height: "18px",
                pointerEvents: "none",
              }}
            />
          </div>
        </div>

        <div className='d-flex justify-content-end my-4'>
          <NaviGate />

          <button
            className='btn btn-primary py-1'
            onClick={() => openAddModal()}
          >
            Add Branch
          </button>
        </div>

        <div className="row">
          {/* {entities.map((entity, index) => ( */}
          {Array.isArray(Shops) && Shops
            .filter(
              (shop) =>
                (shop?.shop_title || "").toLowerCase().includes((search || "").toLowerCase())
            ).map((entity, index) => (
              <div className="col-12 col-md-4 col-lg-4 mb-2" key={index}>
                {/* {console.log("entity data:", entity)} */}
                <div
                  className="card h-100 text-center"
                >
                  {entity?.shop_title != "Top Tecno" && (
                    <div className='d-flex justify-content-end'>
                      <div className='mt-2 mx-3 text-end' role="button" onClick={() => handleEdit(entity)}>
                        <i class="fas fa-edit text-success"></i>
                      </div>
                      <div className='mt-2 mx-3 text-danger text-end' role="button" onClick={() => handledeleteModal(entity.shop_id)}>
                        <i class="fas fa-trash text-danger"></i>
                      </div>
                    </div>
                  )}
                  <div
                    // onClick={() => {
                    //             setLocalStorage("SHOP", JSON.stringify(entity))
                    //             setShopItem(JSON.stringify(entity))
                    //             // window.location.href = "/inventory"
                    //             console.log(window.location.pathname)
                    //             if ("/shops-branch" == window.location.pathname) {
                    //               window.location.href = "/Menu"
                    //             } else {
                    //               window.location.href = "/inventory"
                    //             }
                    //           }}

                    //           role='button'
                    className="card-body d-flex flex-column align-items-center justify-content-center">
                    <img
                      src={company_logo || '/assets/images/tech_logo.webp'}
                      style={{ width: '100px' }}
                    ></img>
                    <h4 className="card-title mt-3">{entity.shop_title}</h4>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {deletemodel && (
          <Deletemodel
            setShowModal={() => showDeletemodel(false)}
            handleDelete={handleDelete}
          />
        )}

        <EditShops
          showModal={ShowEditModal}
          setShowModal={() => openEditModal()}
          fetchdata={() => fetchShops()}
          selectedShops={selectedShops}
          AddorEdit={addoredit}
        />
      </div>
    </div>
  )
}

export default ShopsBranch
